module.exports = __webpack_public_path__ + "static/media/slideImgFour@2x.1b4e5415.svg";